import SweepRequestStatus from './schema/SweepRequestStatus';
import SweepOptionType from './schema/SweepOptionType';
import SweepStore from './schema/SweepStore';
import { createStore } from 'satcheljs';

const defaultSweepStore: SweepStore = {
    sweepDestinationFolderId: null,
    isSweepDialogShown: false,
    sweepOptionType: SweepOptionType.All,
    sweepRequestStatus: SweepRequestStatus.NotInitiated,
};

export default createStore<SweepStore>('sweepStore', defaultSweepStore)();
